import { mlkApi } from './mlk.api';

export const {
  useGetOrderQuery,
  useUpsertReviewMutation,
  useSignInMutation,
  useSignUpMutation,
  useConfirmEmailMutation,
  useResendConfirmationCodeMutation,
  useGoogleSignInMutation,
  useUpdateProfileMutation,
  useFacebookSignInMutation,
  useGetProfileQuery,
  useUpsertAddressMutation,
  useGetPickupPointsQuery,
  useGetAddressesQuery,
  useGetGeoInfoMutation,
  useGetOrdersQuery,
  useGetDriverLocationQuery,
  useUpdateOrderMutation,
  useDeleteAddressMutation,
  useRequestResetPasswordMutation,
  useResetPasswordMutation,
  useUpdatePasswordMutation,
  useCheckoutMutation,
  useAddCartMutation,
  useGetCartQuery,
  useDeleteCartItemMutation,
  useGetServiceOptionsQuery,
  useIsValidAddressMutation,
  useGetPurchaseQuery,
  usePurchaseNotLoggedFreeItemMutation,
  useGetPurchasesQuery,
  usePurchaseFreeItemMutation,
  useEditCartItemMutation,
  useAskRefundMutation,
  useSentRequestSupportMutation,
} = mlkApi;
